import { CHECKOUT_TOKEN } from '@/constants/params';
import { getPublisherToken } from './publisher';
import { getQueryParam } from './queryParams';
import { getPlatform } from './getPlatform';

export const getCheckoutToken = () => {
  const searchParams = new URLSearchParams(window.location.search);
  const checkoutToken = searchParams.get(CHECKOUT_TOKEN) || '';
  return checkoutToken || getPublisherToken();
};

export const getCheckoutRequestOptions = () => {
  const sdkVersion = getQueryParam('sdk-version');
  const sourceVersion = getQueryParam('source-version');
  const platform = getPlatform();
  const resource = getQueryParam('resource');
  const engine = getQueryParam('engine');

  return {
    headers: {
      'x-source-version': sourceVersion,
      'x-sdk-version': sdkVersion,
      'x-client-platform': platform,
      'x-resource': resource,
      'x-engine': engine,
    },
  };
};
